class CustomUpsellProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = document.querySelector('form[action="/cart/add"]');
    this.checkboxes = this.querySelectorAll("input[data-variant-id]");

    this.checkboxes.forEach((checkbox) => {
      if (!checkbox.dataset.variantId) {
        return;
      }
  
      checkbox.removeAttribute("disabled");
      checkbox.addEventListener('click', () => this.updateInputs());
    });
  }

  updateInputs() {
    this.checkboxes.forEach(checkbox => {
      const hiddenInput = this.form.querySelector(`input[value="${checkbox.dataset.variantId}"]`);
      if (hiddenInput) hiddenInput.remove();
    });
    
    Array.from(this.checkboxes)
      .filter(checkbox => checkbox.checked)
      .forEach((checkbox, index) => {
        const newInput = document.createElement('input');
        newInput.type = 'hidden';
        newInput.name = `items[${index}][id]`;
        newInput.value = checkbox.dataset.variantId;

        this.form.appendChild(newInput);
      })
  }
}

if (!customElements.get("custom-upsell-products")) {
  customElements.define("custom-upsell-products", CustomUpsellProducts);
}
